import { createSlice } from '@reduxjs/toolkit';

import {
  ADD_ERROR_MESSAGE,
  ADD_SUCCESS_MESSAGE,
  DEFAULT_MODULE_NAME,
  DELETE_ERROR_MESSAGE,
  DELETE_SUCCESS_MESSAGE,
  RESTORE_ERROR_MESSAGE,
  RESTORE_SUCCESS_MESSAGE,
  UPDATE_ERROR_MESSAGE,
  UPDATE_SUCCESS_MESSAGE,
} from '../../../utils/constants';

const snackSlice = createSlice({
  name: 'snack',
  initialState: {
    open: false,
    severity: 'success',
    message: '',
    actionType: 'SAVE',
    hasError: false,
  },
  reducers: {
    openSnackbar: (state, action) => {
      let severity = action.payload?.severity ?? 'success';
      let message = action.payload?.message ?? '';

      let defaultAction = message ? '' : 'SAVE';

      const actionType =
        action.payload?.actionType?.toUpperCase() ?? defaultAction;
      const hasError = action.payload?.hasError ?? false;
      severity = hasError ? 'error' : severity;
      const moduleName =
        action.payload?.moduleName ?? DEFAULT_MODULE_NAME;
      let msg = `${moduleName}: ${message}`;

      if (actionType === 'REMOVE') {
        msg = `${msg}${
          hasError ? DELETE_ERROR_MESSAGE : DELETE_SUCCESS_MESSAGE
        }`;
      } else if (actionType === 'RESTORE') {
        msg = `${msg}${
          hasError ? RESTORE_ERROR_MESSAGE : RESTORE_SUCCESS_MESSAGE
        }`;
      } else if (actionType === 'ADD') {
        msg = `${msg}${
          hasError ? ADD_ERROR_MESSAGE : ADD_SUCCESS_MESSAGE
        }`;
      } else if (actionType === 'EDIT') {
        msg = `${msg}${
          hasError ? UPDATE_ERROR_MESSAGE : UPDATE_SUCCESS_MESSAGE
        }`;
      } else if (actionType === 'SAVE') {
        msg = `${msg} ${
          hasError ? 'Error saving data' : 'Data Saved Successfully'
        }`;
      }

      state.open = true;
      state.severity = severity;
      state.message = msg;
      state.actionType = actionType;
      state.hasError = hasError;
    },

    closeSnackbar: state => {
      state.open = false;
      state.message = '';
      state.actionType = '';
      state.hasError = false;
    },
  },
});

export const { openSnackbar, closeSnackbar } = snackSlice.actions;
export default snackSlice.reducer;

export const selectOpen = state => state.snack.open;
export const selectMessage = state => state.snack.message;
export const selectSeverity = state => state.snack.severity;
